import { ApplicationFeature, DefaultApplicationFeatures } from "./Features";
import { Partner } from "./Partners";

export type Organization = {
    id:string,
    companyInfo: CompanyInfo,
    partner: Partner | null
}

export type OrganizationListView = {
    id:string,
    companyInfo: CompanyInfo,
    partner: Partner | null,
    sites: string[],
}

export type OrganizationView = {
    id:string,
    companyInfo: CompanyInfo,
    partner: Partner | null,
    sites: string[],
    contacts:OrganizationContact[],
    deals:OrganizationDeal[]
}

export const OrganizationFlags = [ 'test', 'demo' ] as const;
export type OrganizationFlag = typeof OrganizationFlags[number];

export type CompanyInfo = {
    name: string,
    address: string,
    altAddress: string,
    city: string,
    zip: string,
    phone: string,
    website: string,
    note: string,
    flags: OrganizationFlag[]
}

export const OrganizationContactFlags = [ 'beslutningstager', 'leder' ] as const;
export type OrganizationContactFlag = typeof OrganizationContactFlags[number];

export type OrganizationContact = {
    id:string,
    name:string,
    email:string,
    phone:string,
    flags: OrganizationContactFlag[],
    note: string
}

export const PrimaryDealTypes = ['Lovservice', 'Lovpakken', 'AMO Pakken', 'andet' ] as const;
export type PrimaryDealType = typeof PrimaryDealTypes[number];

export const DealFlags = ['test'] as const;
export type DealFlag = typeof DealFlags[number];

export const Currencies = ['DKK', 'EUR'] as const;
export type Currency = typeof Currencies[number];

export const PaymentStatuses = ['invoice-sent', 'paid'] as const;
export type PaymentStatus = typeof PaymentStatuses[number];

export const PaymentCycleTypes = ['monthly', 'quarterly', 'yearly'] as const;
export type PaymentCycle = typeof PaymentCycleTypes[number];

export const PaymentListEntryStatuses = ['invoice-sent', 'paid'] as const;
export type PaymentListEntryStatus = typeof PaymentListEntryStatuses[number];

export type OrganizationDeal = {
    id:string,
    title:string,
    start:Date | null,
    end:Date | null,
    dealType: PrimaryDealType,
    flags: DealFlag[],
    payment:{
        status: PaymentStatus,
        cycle: PaymentCycle,
        listPrice: number,
        agreedPrice: number,
        currency: Currency,
        payments: {
            time:Date,
            amount:number,
            currency: Currency,
            status: PaymentListEntryStatus,
            note: string;
        }[],
        reminderDate: Date | null,
    }
}

export const OrganizationNoteFlags = ['generel note', 'korrespondance', 'kontrakt', 'opfølgning'] as const;
export type OrganizationNoteFlag = typeof OrganizationNoteFlags[number];

export type OrganizationNote = {
    id:string,
    flags: OrganizationNoteFlag[],
    note:string,
    deleted:boolean,
    created: Date,
    updated: Date | null
    createdByUserId:string
}

export function getDefaultCompanyInfo (): CompanyInfo
{
    return {
        name: '',
        address: '',
        altAddress: '',
        city: '',
        zip: '',
        phone: '',
        website: '',
        note: '',
        flags: []
    };
}
